import { InvoiceDTO, InvoiceNewDTO } from "@gymflow/types";
import { useTranslation } from "react-i18next";

import {
  DotBadge,
  DotBadgeProps,
  DotBadgeVariantsType,
} from "../../../atoms/DotBadge";

export type InvoiceBadgeProps = {
  invoice: Pick<InvoiceDTO, "status">;
  size?: DotBadgeVariantsType["size"];
};

export const InvoiceBadge = ({
  invoice,
  size = "small",
}: InvoiceBadgeProps) => {
  const { t } = useTranslation();
  return (
    <DotBadge
      intent={
        (
          {
            PAID: "success",
            SCHEDULED: "secondary",
            RE_SCHEDULE: "warning",
            PAST_DUE: "error",
            DISPUTED: "error",
            VOID: "gray",
            REFUNDED: "gray",
            PROCESSING: "warning",
            WRITTEN_OFF: "gray",
            AWAITING_AUTHORIZATION: "warning",
          } as {
            [key in InvoiceNewDTO["status"]]: DotBadgeProps["intent"];
          }
        )[invoice.status]
      }
      size={size}
    >
      {t(`portal.common.invoiceStatus.${invoice.status}`)}
    </DotBadge>
  );
};
